import { Box, Switch, Tooltip } from '@optiaxiom/react';

import { useRegistryStats, useRegistryTooltip } from './hooks';
import type { RegistryStatusToggleProps } from './types';

export function RegistryStatusToggle({
  toolRow,
  onBulkToggle,
  isLoading,
}: RegistryStatusToggleProps) {
  const {
    allEnabled,
    allDisabled,
    enabledCount,
    totalCount,
    functionIds,
    allSystemTools,
    hasSystemTools,
    hasNonSystemTools,
  } = useRegistryStats(toolRow);

  const tooltipContent = useRegistryTooltip(
    allSystemTools,
    hasSystemTools,
    hasNonSystemTools,
    totalCount,
    allEnabled,
    allDisabled,
    enabledCount
  );

  if (!toolRow.isRegistry) {
    return null;
  }

  const handleToggle = () => {
    if (totalCount === 0) return;

    // If all are disabled, enable all. Otherwise, disable all.
    const action = allDisabled ? 'enable' : 'disable';
    onBulkToggle(toolRow.registry.id, functionIds, action);
  };

  return (
    <Tooltip content={tooltipContent}>
      <Box display="flex" alignItems="center" gap="8">
        <Switch
          disabled={isLoading || totalCount === 0 || allSystemTools}
          checked={!allDisabled}
          onCheckedChange={handleToggle}
          aria-label={`Toggle all tools in ${toolRow.name}`}
        />
      </Box>
    </Tooltip>
  );
}
